// extracted by mini-css-extract-plugin
export default {"partnerStyles":"Partners_partnerStyles__DiM55","partners":"Partners_partners__ZHW+r","overlay":"Partners_overlay__tkIfP"};